// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import StopOutlinedSvg from "@fishx/icons-svg/es/asn/StopOutlined";
import FishxIcon from '../components/FishxIcon';

var StopOutlined = function StopOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: StopOutlinedSvg
  }));
};

StopOutlined.displayName = 'StopOutlined';
export default React.forwardRef(StopOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/StopOutlined.js
// module id = 4197
// module chunks = 0